import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { DefaultSquireLogo } from '../../../components/default-squire-logo/default-squire-logo';
import styles from './styles.module.scss';
import { ShimmerBar } from '../../../../../infra/ui/shimmer';
export var Notification = function (_a) {
    var _b, _c;
    var logoImage = _a.logoImage, className = _a.className, contentClassName = _a.contentClassName, _d = _a.showBackgroundEffect, showBackgroundEffect = _d === void 0 ? true : _d, children = _a.children, isLoading = _a.isLoading;
    var renderLogo = function () {
        if (isLoading) {
            return _jsx(ShimmerBar, { height: "56px", width: "56px", borderRadius: "14px" });
        }
        if (logoImage) {
            return _jsx("img", { className: styles['notification-logo'], src: logoImage, width: 64, height: 64, alt: "logo" });
        }
        return _jsx(DefaultSquireLogo, {});
    };
    return (_jsxs("div", { className: classNames(styles.notification, className, (_b = {},
            _b[styles['with-background-effect']] = showBackgroundEffect,
            _b)), children: [_jsx("div", { className: styles['notification-logo'], children: renderLogo() }), _jsx("div", { className: classNames(styles['notification-content'], contentClassName, (_c = {},
                    _c[styles['with-background-effect']] = showBackgroundEffect,
                    _c)), children: isLoading ? (_jsxs("div", { className: styles['notification-loading-column'], children: [_jsx(ShimmerBar, { className: styles['notification-loading-bar'], width: "60%", height: "16px" }), _jsx(ShimmerBar, { className: styles['notification-loading-bar'], width: "100%" }), _jsx(ShimmerBar, { className: styles['notification-loading-bar'], width: "30%" })] })) : (children) })] }));
};
